var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{style:({height: _vm.offsetWidth/2+'px'}),attrs:{"id":"swipe"}},[_c('mt-swipe',{attrs:{"auto":4000}},_vm._l((_vm.swipes),function(item,index){return _c('mt-swipe-item',{key:index},[_c('img',{attrs:{"src":item}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }